<template>
  <div>
    <!-- Versione Italiana -->
    <storytelling-import-presentazione v-if="currentLang === 'it'" />

    <!-- Versione Inglese -->
    <storytelling-import-presentazione-eng v-else />
  </div>
</template>

<script>
import StorytellingImportPresentazione from './Storytelling_import_Presentazione.vue'
import StorytellingImportPresentazioneEng from './Storytelling_import_Presentazione_eng.vue'

export default {
  name: 'ParentComponent',
  components: {
    StorytellingImportPresentazione,
    StorytellingImportPresentazioneEng
  },
  computed: {
    // Recupera la lingua attiva dal sistema i18n
    currentLang() {
      // Modifica 'eng' o 'en' in base al valore impostato nel tuo sistema per eng.json
      return this.$i18n.locale
    }
  }
}
</script>